<mat-progress-bar
  class="progress-margin"
  color="primary"
  *ngIf="loadingInit"
  mode="indeterminate"
></mat-progress-bar>

<form [formGroup]="formGroup">
  <div class="card-content">
    <div class="card-inline full-width">
      <div>
        <label  *ngIf="f.ValorizationEdit.errors && f.ValorizationEdit.errors.validValorizationPrincipal"
        class="alert-message">{{ f.ValorizationEdit.errors.valorizationErrorDescription }}</label>

        <label class="alert-message" *ngIf="!isOrderInSector"
          >No se puede modificar la valorización porque la orden no se encuentra
          en el sector ( {{ sectorName }} )</label
        >
        <label class="alert-message" *ngIf="existsCurrentInvoice"
          >No se puede modificar la valorización porque existe una cobranza
          realizada</label
        >


        <app-valorization-edit-control
          [isDisabled]="isReadOnly"
          [isRegistered]="isRegistered"
          [editableAgreementPriceIds]="editableAgreementPriceIds"
          (onAddPracticeClick)="addPracticeClick($event)"
          (onRefreshPracticeClick)="refreshPractice($event)"
          (onRecalculateClick)="recalculate()"
          [loading]="loading || loadingInit"
          formControlName="ValorizationEdit"
        >
        </app-valorization-edit-control>
      </div>
    </div>
  </div>
</form>
